import { render, staticRenderFns } from "./jydzmpc.vue?vue&type=template&id=1bf3cf5a&scoped=true&"
import script from "./jydzmpc.vue?vue&type=script&lang=js&"
export * from "./jydzmpc.vue?vue&type=script&lang=js&"
import style0 from "./jydzmpc.vue?vue&type=style&index=0&id=1bf3cf5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3cf5a",
  null
  
)

export default component.exports